import './AbookpickerModal.scss';
import { portalOverlayClassName } from '@srm/ui/lib/portalOverlay';
import { FC, useState } from 'react';
import clsx from 'clsx';
import Button from '@srm/ui/button';
import Modal from '@srm/ui/modal';
import { IAbookTab, IExternalSearchAbook } from '@models/Forms/IForms';
import { IAddressBookData } from '@models/addressbook/IAddressBookData';
import SearchModeControl from './ModeControls/SearchModeControl';
import { AddressBookService } from '@services/AddressBookService';

export interface IAbookExternalSearchModalProp {
    settings: IExternalSearchAbook;
    onClose: () => void;
    onSubmit: (data: IAddressBookData[]) => void;
    currentTab: IAbookTab;
    getParams: (options: any) => string;
}

const AbookExternalSearchModal: FC<IAbookExternalSearchModalProp> = (p: IAbookExternalSearchModalProp) => {
    const [selectedRowItems, setSelectedRowItems] = useState<IAddressBookData[]>([]);
    const ModalFooter = ({
        onClose,
        onSubmit,
    }: {
        onClose: () => void;
        onSubmit: (data: IAddressBookData[]) => void;
    }) => (
        <div className={'abookModal_footer'}>
            <Button
                onClick={() => {
                    if (selectedRowItems.length > 0) {
                        AddressBookService.saveExternalSearch(p.settings.submitApiUrl, selectedRowItems[0]).then(() => {
                            onSubmit(selectedRowItems);
                            onClose();
                        });
                    } else {
                        onClose();
                    }
                }}
                size="sm"
            >
                Выбрать
            </Button>
            <Button onClick={onClose} variant="light" size="sm">
                Отменить
            </Button>
        </div>
    );

    return (
        <Modal
            className={clsx('abookExternalSearchModal', portalOverlayClassName)}
            size="content"
            onClose={p.onClose}
            hasUnsavedInput={() => selectedRowItems.length > 0}
            footer={<ModalFooter onClose={p.onClose} onSubmit={p.onSubmit} />}
            header={p.settings.buttonName}
        >
            <div className="abook-container">
                <div className="abook-grid">
                    <SearchModeControl
                        currentTab={p.currentTab}
                        searchApiUrl={p.settings.searchApiUrl}
                        onSelectedRowItems={(val: IAddressBookData[]) => {
                            setSelectedRowItems(val);
                        }}
                        getParams={p.getParams}
                        isMultiple={false}
                        selected={[]}
                        title={''}
                        formValues={''}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default AbookExternalSearchModal;
